import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { Users } from "lucide-react"
import { McPill } from "../../shared/McPill"
import { SectionLabel } from "../../shared/SectionLabel"

interface InquiryRecipientsSectionProps {
  recipientsTo: string[]
  recipientsCc: string[]
}

/** Who the inquiry went to. Renders nothing when neither list has an address. */
export function InquiryRecipientsSection({
  recipientsTo,
  recipientsCc,
}: InquiryRecipientsSectionProps) {
  const { translate } = useTranslation()
  if (recipientsTo.length === 0 && recipientsCc.length === 0) return null

  return (
    <div className="border-b border-grey4 px-4 py-4">
      <SectionLabel className="mb-2 flex items-center gap-1.5">
        <Users className="h-3.5 w-3.5" />
        {translate("MC_INQ_RECIPIENTS")}
      </SectionLabel>
      <div className="flex flex-wrap gap-1.5">
        {recipientsTo.map((email) => (
          <McPill key={email} tone="muted">
            {email}
          </McPill>
        ))}
        {recipientsCc.map((email) => (
          <McPill key={`cc-${email}`} tone="muted">
            {translate("MC_INQ_EMAIL_CC")}: {email}
          </McPill>
        ))}
      </div>
    </div>
  )
}
